import gql from 'graphql-tag'
import { get, map, lowerCase } from 'lodash'
const QUERY_GET_GROUP_BY_NAME = gql`
query getGroups {
  getGroups {
    results {
      ... on ABMGroup {
        id
        name
        description
        alias
        usersCount
      }
    }
  }
}
`

const checkIfGroupNameExists = ({ variables, client, ...props }) => {
  return client
    .query(({ query: QUERY_GET_GROUP_BY_NAME, fetchPolicy: 'network-only', variables }))
    .then(({ data }) => (map(get(data, 'getGroups.results', []), ({ alias }) => (lowerCase(alias)))))
}

export default checkIfGroupNameExists
